import { Token } from '../model';
import type { TokenRegister } from './types';

export const getYbUSDToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.ybUSD,
    symbol: 'ybUSD',
    addressL1: sdks.L1.getContractAddress('YbUSD'),
    addressL2: sdks.L2.getContractAddress('YbUSD'),
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 6,
    Icon: () => null,
  };
};
